import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isResourceGroupRemovalRequestFailure(group) {
      const state = getState().find(
        ({ group: { uuid } }) => uuid === group.uuid,
      );

      return state ? state.requestState.isFailure : false;
    },
    isResourceGroupRemovalRequestPending(group) {
      const state = getState().find(
        ({ group: { uuid } }) => uuid === group.uuid,
      );

      return state ? state.requestState.isPending : false;
    },
    isResourceGroupRemovalRequestSuccess(group) {
      const state = getState().find(
        ({ group: { uuid } }) => uuid === group.uuid,
      );

      return state ? state.requestState.isSuccessful : false;
    },
  };
}

export { createSelector };
